export enum Config {
  API_URL_LS_KEY = 'apiUrl',
  APP_BRAND_LS_KEY = 'appBrand',
  BUILDING_UUID_LS_KEY = 'buildingUuid',
  LOCALE_LS_KEY = 'locale',
  AUTH_TOKEN_LS_KEY = 'authToken',
  APP_INSTANCE_CONFIG_UUID = 'appInstanceConfigUuid'
}
